export default '/static/frontend/ReachDigital/12gobiking/dist/assets/chronopost-9d28d0a7.png'